<template>
  <v-app style="background-color: #f8f9fb">
    <v-divider></v-divider>
    <br /><br />

    <v-container
      style="background-color: #eee"
      id="templates"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-message-text-outline"
            title="Templates"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <v-col cols="12" sm="6">
                  <span>Nome do Template</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="nome"
                    label="Nome do Template"
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Empresa</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="empresasFiltradas"
                    v-model="empresaSelecionada"
                    filled
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    label="Empresa"
                  >
                  </v-select>
                </v-col>
                
                <v-col cols="12" sm="6">
                  <span>ID Externo</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="idExterno"
                    label="ID Externo"
                    hint="Campo opcional"
                    filled
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" sm="6">
                  <v-switch
                    v-model="ura"
                    label="URA"
                    color="primary"
                    hint="Marque se o template é para URA"
                    persistent-hint
                    class="mt-2"
                  ></v-switch>
                </v-col>
                
                <v-col cols="6" sm="3" v-if="ura">
                  <v-switch
                    v-model="inicio"
                    label="Início"
                    color="primary"
                    hint="Marque se este é o template inicial da URA"
                    persistent-hint
                    class="mt-2"
                    @change="onInicioChange"
                  ></v-switch>
                </v-col>

                <v-col cols="6" sm="3" v-if="ura">
                  <v-switch
                    v-model="final"
                    label="Final"
                    color="primary"
                    hint="Marque se este é o template final do atendimento"
                    persistent-hint
                    class="mt-2"
                    @change="onFinalChange"
                  ></v-switch>
                </v-col>

                <v-col cols="6" sm="3" v-if="ura">
                  <v-switch
                    v-model="acao"
                    label="Ação"
                    color="primary"
                    hint="Marque se o template é de ação na URA"
                    persistent-hint
                    class="mt-2"
                  ></v-switch>
                </v-col>

                <v-col cols="12" sm="6" v-if="exibirTelefoneEmpresa">
                  <span>Telefone da Empresa</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="telefonesEmpresa"
                    v-model="telefoneEmpresaSelecionado"
                    item-text="descricao"
                    item-value="numero"
                    filled
                    clearable
                    label="Telefone da Empresa"
                    hint="Opcional: vazio usa o template padrão da empresa"
                    persistent-hint
                    no-data-text="Nenhum telefone cadastrado para esta empresa"
                  ></v-select>
                </v-col>

                <v-col cols="12" v-if="ura && acao">
                  <span>Código Ação</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="codigo_acao"
                    label="Código Ação"
                    hint="Campo opcional"
                    persistent-hint
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span>Texto do Template</span>
                    <v-btn
                      small
                      outlined
                      color="primary"
                      @click="dialogVariaveis = true"
                    >
                      <v-icon left small>mdi-code-braces</v-icon>
                      Variáveis disponíveis
                    </v-btn>
                  </div>
                  <v-textarea
                    ref="textoField"
                    dense
                    solo-inverted
                    v-model="texto"
                    label="Texto do Template"
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    filled
                    rows="5"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  v-if="templateEditandoId"
                  color="grey"
                  @click="cancelarEdicao"
                  class="mr-2"
                >
                  <v-icon left>mdi-close</v-icon> Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="salvando"
                  :disabled="!podeSalvar"
                  @click="salvarTemplate"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ templateEditandoId ? "Atualizar" : "Salvar" }}
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-data-table
              style="margin-top: 1rem"
              :headers="templates_header"
              :items="listaTemplates"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="carregandoTemplates"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.id }}
                  </td>

                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ row.item.nome }}
                  </td>

                  <td class="linha" style="width: 18%; font-size: 14px">
                    {{ row.item.empresa }}
                  </td>

                  <td class="linha" style="width: 12%; font-size: 14px">
                    {{ formatarTelefoneTemplate(row.item) }}
                  </td>

                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ truncateText(row.item.texto, 100) }}
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.idExterno || '-' }}
                  </td>

                  <td class="linha" style="width: 5%; font-size: 14px">
                    <v-icon v-if="row.item.ura" color="success" small>mdi-check</v-icon>
                    <v-icon v-else color="grey" small>mdi-minus</v-icon>
                  </td>

                  <td class="linha" style="width: 5%; font-size: 14px">
                    <template v-if="row.item.ura">
                      <v-icon v-if="row.item.inicio" color="success" small>mdi-check</v-icon>
                      <v-icon v-else color="grey" small>mdi-minus</v-icon>
                    </template>
                    <span v-else>-</span>
                  </td>

                  <td class="linha" style="width: 5%; font-size: 14px">
                    <template v-if="row.item.ura">
                      <v-icon v-if="row.item._final" color="success" small>mdi-check</v-icon>
                      <v-icon v-else color="grey" small>mdi-minus</v-icon>
                    </template>
                    <span v-else>-</span>
                  </td>

                  <td class="linha" style="width: 5%; font-size: 14px">
                    <template v-if="row.item.ura">
                      <v-icon v-if="row.item.acao" color="success" small>mdi-check</v-icon>
                      <v-icon v-else color="grey" small>mdi-minus</v-icon>
                    </template>
                    <span v-else>-</span>
                  </td>

                  <td class="linha" style="width: 12%; font-size: 14px">
                    <v-btn
                      @click="editarTemplate(row.item)"
                      fab
                      small
                      color="primary"
                      class="mr-2"
                      title="Editar template"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      @click="deletarTemplate(row.item.id)"
                      fab
                      small
                      color="error"
                      title="Excluir template"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Dialog Variáveis -->
    <v-dialog v-model="dialogVariaveis" max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-code-braces</v-icon>
          Variáveis disponíveis
        </v-card-title>

        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersVariaveis"
            :items="variaveisDisponiveis"
            dense
            hide-default-footer
            class="elevation-0"
          >
            <template v-slot:item.nome="{ item }">
              <code>{{ item.nome }}</code>
            </template>

            <template v-slot:item.acoes="{ item }">
              <v-btn text small color="primary" @click="inserirVariavel(item.nome)">
                <v-icon small>mdi-plus-circle-outline</v-icon>
                Inserir
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text small @click="dialogVariaveis = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Wazzup from "@/services/wazzup";

export default {
  name: "Templates",
  mounted() {
    this.carregarListaTemplates();
  },
  data() {
    return {
      rules: {
        required: (v) => !!v || "Obrigatório.",
      },
      valid: true,

      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ],
      empresaSelecionada: "",
      telefoneEmpresaSelecionado: null,
      empresasTelefones: [
        {
          nome: "PREVIDA",
          aliases: ["PREVIDA"],
          telefones: [
            { label: "Ativo", numero: "558282308177", numeroFormatado: "(82) 8230-8177" },
            { label: "Receptivo", numero: "558000091700", numeroFormatado: "0800 009 1700" },
          ],
        },
        {
          nome: "MEMORIAL PARQUE MACEIO",
          aliases: ["MEMORIAL PARQUE MACEIO", "MEMORIAL PARQUE MACEIÃ“"],
          telefones: [
            { label: "Ativo", numero: "558299289412", numeroFormatado: "(82) 9928-9412" },
            { label: "Receptivo", numero: "558291229510", numeroFormatado: "(82) 9122-9510" },
          ],
        },
        {
          nome: "PARQUE DAS FLORES",
          aliases: ["PARQUE DAS FLORES"],
          telefones: [
            { label: "Ativo", numero: "558296411028", numeroFormatado: "(82) 9641-1028" },
            { label: "Receptivo", numero: "558233389844", numeroFormatado: "(82) 3338-9844" },
          ],
        },
        {
          nome: "CEMITERIO PREVIDA",
          aliases: ["CEMITERIO PREVIDA"],
          telefones: [
            { label: "Principal", numero: "558000829000", numeroFormatado: "0800 082 9000" },
          ],
        },
        {
          nome: "CEMITERIO PREVIDA SAO MIGUEL",
          aliases: ["CEMITERIO PREVIDA SAO MIGUEL", "CEMITERIO PREVIDA SÃƒO MIGUEL"],
          telefones: [
            { label: "Principal", numero: "558000829000", numeroFormatado: "0800 082 9000" },
          ],
        },
        {
          nome: "PARQUE DO AGRESTE",
          aliases: ["PARQUE DO AGRESTE"],
          telefones: [
            { label: "Principal", numero: "558000829000", numeroFormatado: "0800 082 9000" },
          ],
        },
        {
          nome: "A FLOR DO CAFE",
          aliases: ["A FLOR DO CAFE", "A FLOR DO CAFÃ‰"],
          telefones: [
            { label: "Principal", numero: "558000829000", numeroFormatado: "0800 082 9000" },
          ],
        },
      ],

      nome: "",
      texto: "",
      idExterno: "",
      ura: false,
      inicio: false,
      final: false,
      acao: false,
      codigo_acao: "",
      templateEditandoId: null,

      salvando: false,

      dialogVariaveis: false,
      headersVariaveis: [
        { text: "Variável", value: "nome", sortable: false },
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "", value: "acoes", sortable: false, align: "end" },
      ],
      variaveisDisponiveis: [
        { nome: "{{NumeroProtocolo}}", descricao: "Número do protocolo do atendimento" },
      ],

      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },

      listaTemplates: [],
      carregandoTemplates: false,
      templates_header: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "Empresa", value: "empresa" },
        { text: "Telefone", value: "telefoneEmpresa" },
        { text: "Texto", value: "texto" },
        { text: "ID Externo", value: "idExterno" },
        { text: "URA", value: "ura" },
        { text: "Início", value: "inicio" },
        { text: "Final", value: "final" },
        { text: "Ação", value: "acao" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    empresasFiltradas() {
      // Filtra as empresas com base nas permissões do usuário
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    exibirTelefoneEmpresa() {
      return this.ura && (this.inicio || this.final);
    },
    telefonesEmpresa() {
      return this.obterTelefonesEmpresa(this.empresaSelecionada).map((telefone) => ({
        ...telefone,
        descricao: `${telefone.label} - ${telefone.numeroFormatado}`,
      }));
    },
    podeSalvar() {
      return (
        this.nome &&
        this.empresaSelecionada &&
        this.texto &&
        !this.salvando
      );
    },
  },
  watch: {
    empresaSelecionada() {
      if (
        this.telefoneEmpresaSelecionado &&
        !this.telefonesEmpresa.some((telefone) => telefone.numero === this.telefoneEmpresaSelecionado)
      ) {
        this.telefoneEmpresaSelecionado = null;
      }
    },
    exibirTelefoneEmpresa(valor) {
      if (!valor) {
        this.telefoneEmpresaSelecionado = null;
      }
    },
  },
  methods: {
    hasPermission(empresa) {
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (!user || !user.roles) return false;

      if (user.roles.includes("ROLE_ADMIN")) {
        return true;
      }

      const requiredRoles = empresa
        .split(" ")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => user.roles.includes(role));
    },

    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    normalizarNomeEmpresa(empresa) {
      return String(empresa || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/Ãƒâ€¡/g, "C")
        .replace(/ÃƒÆ’/g, "A")
        .replace(/Ãƒâ€°/g, "E")
        .replace(/Ãƒâ€œ/g, "O")
        .toUpperCase()
        .trim();
    },

    identificarEmpresaPorPalavrasChave(empresaNormalizada) {
      if (
        empresaNormalizada.includes("CEMITERIO") &&
        empresaNormalizada.includes("MIGUEL")
      ) {
        return "CEMITERIO PREVIDA SAO MIGUEL";
      }

      if (empresaNormalizada.includes("CEMITERIO")) {
        return "CEMITERIO PREVIDA";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "PARQUE DO AGRESTE";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "PARQUE DAS FLORES";
      }

      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEI")
      ) {
        return "MEMORIAL PARQUE MACEIO";
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "PREVIDA";
      }

      if (
        empresaNormalizada.includes("FLOR") &&
        empresaNormalizada.includes("CAF")
      ) {
        return "A FLOR DO CAFE";
      }

      return null;
    },

    obterConfigTelefonesEmpresa(empresa) {
      const empresaNormalizada = this.normalizarNomeEmpresa(empresa);

      const configExata = this.empresasTelefones.find((config) => {
        const nomes = [config.nome, ...(config.aliases || [])];
        return nomes.some(
          (nome) => this.normalizarNomeEmpresa(nome) === empresaNormalizada,
        );
      });

      if (configExata) {
        return configExata;
      }

      const nomePorPalavraChave =
        this.identificarEmpresaPorPalavrasChave(empresaNormalizada);

      return (
        this.empresasTelefones.find(
          (config) => config.nome === nomePorPalavraChave,
        ) || null
      );
    },

    obterTelefonesEmpresa(empresa) {
      const config = this.obterConfigTelefonesEmpresa(empresa);
      return config ? [...config.telefones] : [];
    },

    normalizarTelefone(telefone) {
      return telefone ? String(telefone).replace(/\D/g, "") : null;
    },

    formatarTelefoneTemplate(template) {
      const telefone = this.normalizarTelefone(template.telefoneEmpresa);
      if (!telefone) {
        return "-";
      }

      const telefoneConfig = this
        .obterTelefonesEmpresa(template.empresa)
        .find((item) => item.numero === telefone);

      return telefoneConfig
        ? `${telefoneConfig.label} - ${telefoneConfig.numeroFormatado}`
        : telefone;
    },

    salvarTemplate() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.podeSalvar) {
        return;
      }

      this.salvando = true;

      const payload = {
        id: this.templateEditandoId,
        nome: this.nome,
        texto: this.texto,
        empresa: this.empresaSelecionada,
        telefoneEmpresa: this.exibirTelefoneEmpresa
          ? this.normalizarTelefone(this.telefoneEmpresaSelecionado)
          : null,
        idExterno: this.idExterno,
        ura: this.ura,
        inicio: this.ura ? this.inicio : false,
        _final: this.ura ? this.final : false,
        acao: this.ura ? this.acao : false,
        codigo_acao: this.ura && this.acao ? this.codigo_acao || "" : "",
      };

      const method = this.templateEditandoId ? 
        Wazzup.atualizarTemplate(this.templateEditandoId, payload) : 
        Wazzup.criarTemplate(payload);

      method
        .then(() => {
          const mensagem = this.templateEditandoId
            ? "Template atualizado com sucesso!"
            : "Template salvo com sucesso!";
          this.showSnackbar(mensagem, "success");
          // Limpa o formulário
          this.limparFormulario();
          // Recarrega a lista de templates
          this.carregarListaTemplates();
        })
        .catch((e) => {
          // Exibe o erro retornado pelo backend (pode ser erro de template inicial duplicado)
          const msg =
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "Erro ao salvar template.";
          this.showSnackbar(msg, "error", 5000);
        })
        .finally(() => {
          this.salvando = false;
        });
    },

    editarTemplate(template) {
      // Preenche o formulário com os dados do template
      this.templateEditandoId = template.id;
      this.nome = template.nome;
      this.texto = template.texto;
      this.empresaSelecionada = template.empresa;
      this.telefoneEmpresaSelecionado = template.telefoneEmpresa || null;
      this.idExterno = template.idExterno || "";
      this.ura = template.ura || false;
      this.inicio = template.inicio || false;
      this.final = template._final || false;
      this.acao = template.acao || false;
      this.codigo_acao = template.codigo_acao || "";

      // Scroll suave até o formulário
      this.$nextTick(() => {
        const formElement = document.getElementById("templates");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    cancelarEdicao() {
      this.limparFormulario();
    },

    limparFormulario() {
      this.templateEditandoId = null;
      this.nome = "";
      this.texto = "";
      this.empresaSelecionada = "";
      this.telefoneEmpresaSelecionado = null;
      this.idExterno = "";
      this.ura = false;
      this.inicio = false;
      this.final = false;
      this.acao = false;
      this.codigo_acao = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    carregarListaTemplates() {
      this.carregandoTemplates = true;
      Wazzup.listarTemplates()
        .then((resp) => {
          if (resp && resp.status === 200 && resp.data) {
            // A resposta pode vir como array direto ou dentro de um objeto
            if (Array.isArray(resp.data)) {
              this.listaTemplates = resp.data;
            } else if (resp.data.data && Array.isArray(resp.data.data)) {
              this.listaTemplates = resp.data.data;
            } else {
              this.listaTemplates = [];
            }
          } else {
            this.listaTemplates = [];
          }
        })
        .catch((e) => {
          console.error("Erro ao carregar lista de templates:", e);
          this.listaTemplates = [];
        })
        .finally(() => {
          this.carregandoTemplates = false;
        });
    },

    deletarTemplate(id) {
      if (!confirm("Deseja realmente excluir este template?")) {
        return;
      }

      Wazzup.deletarTemplate(id)
        .then(() => {
          this.showSnackbar("Template excluído com sucesso!", "success");
          this.carregarListaTemplates();
        })
        .catch((e) => {
          const msg = e.response?.data?.error || e.message || "Erro ao excluir template.";
          this.showSnackbar(msg, "error", 5000);
        });
    },

    inserirVariavel(variavel) {
      const el = this.$refs.textoField.$el.querySelector("textarea");
      if (el) {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        this.texto = this.texto.substring(0, start) + variavel + this.texto.substring(end);
        this.$nextTick(() => {
          el.focus();
          el.setSelectionRange(start + variavel.length, start + variavel.length);
        });
      } else {
        this.texto = (this.texto || "") + variavel;
      }
      this.dialogVariaveis = false;
    },

    onInicioChange() {
      if (this.inicio) this.final = false;
    },

    onFinalChange() {
      if (this.final) this.inicio = false;
    },

    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.justify-center {
  justify-content: center;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
</style>
